
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator';
import ruleMixin from '@/minix/ruleMixin';
import api from '@/api';

const { requiredRule, maxLengthRule } = ruleMixin.methods;

const { swapInPoint } = api;

@Component
export default class PointCalculatorForm extends Vue {
  @Prop() private name!: string;

  @Prop() private expiredTime!: string;

  @Prop() private rate!: number | null;

  @Prop() private initialNumberOfWishes!: number | null;

  @Prop() private commentUrl!: string;

  @Prop() private itemId!: number | null;

  @Prop({ default: false }) private isEdit!: boolean;

  private loading: boolean = false;

  private valid: boolean = false;

  private items: Array<{ value: number; text: string }> = [];

  private form = {
    name: this.name,
    expiredTime: this.expiredTime,
    rate: this.rate,
    initialNumberOfWishes: this.initialNumberOfWishes,
    commentUrl: this.commentUrl,
    itemId: this.itemId,
  };

  private rules = {
    name: [...requiredRule('名稱'), ...maxLengthRule('名稱', 20)],
    expiredTime: [
      ...requiredRule('點數有效期限文字說明'),
      ...maxLengthRule('點數有效期限文字說明', 100),
    ],
    rate: [
      ...requiredRule('匯率'),
      (v: number) => v > 0 || '匯率不可以小於0',
    ],
    initialNumberOfWishes: [
      ...requiredRule('集氣初始值'),
      (v: number) => v >= 0 || '集氣初始值不可以小於0',
    ],
    commentUrl: [
      ...requiredRule('留言連結'),
      ...maxLengthRule('留言連結', 200),
    ],
  };

  private get inputs() {
    return {
      name: this.name,
      expiredTime: this.expiredTime,
      rate: this.rate,
      initialNumberOfWishes: this.initialNumberOfWishes,
      commentUrl: this.commentUrl,
      itemId: this.itemId,
    };
  }

  @Watch('inputs', { immediate: true })
  private inputsWatcher(val: any) {
    this.form = {
      ...val,
    };
  }

  private async created() {
    const {
      data: { data },
    } = await swapInPoint.itemList();
    this.items = [
      { text: '請選擇', value: null },
      ...data.map((i: any) => ({ text: i.itemName, value: i.itemId })),
    ];
  }

  private cancel() {
    this.$router.back();
  }

  @Emit()
  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      return this.form;
    }
    return null;
  }
}
